import { keys } from "./Keys";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { IEditTagSearchCriteriaDTO, IEditTagSearchResultDeviceDTO  } from "../../services/setpoint-administration-service/Models";
import SetpointAdministrationDataService from "../../services/setpoint-administration-service/SetpointAdministrationService";
import { useQuery } from "react-query";

export type UseGetAvailableUsageObjectParams = {
    groupID: number,
    searchCriteria: IEditTagSearchCriteriaDTO

} & BaseUseQueryParameters<IEditTagSearchResultDeviceDTO[] | undefined>;

export function useGetAvailableUsageObjects({
    groupID,
    searchCriteria,
    enabled,    
    onSuccess,
    onError
}: UseGetAvailableUsageObjectParams) {
    return useQuery<IEditTagSearchResultDeviceDTO[], RestError>(
        keys.getAvailableUsageObjects(groupID, searchCriteria),
        ({ signal }) => {
            return SetpointAdministrationDataService.getAvailableUsageObjects(
                groupID,
                searchCriteria,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            staleTime: Infinity,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            refetchOnReconnect: false,
            retry: false,
        }
    );
}